import { createSlice } from '@reduxjs/toolkit'

const {
  actions: {
    getCmsPageStart,
    getCmsPageSuccess,
    getCmsPageFailure
  },
  reducer
} = createSlice({
  name: 'cms',
  initialState: {
    loading: false,
    cmsDetails: null,
    error: false
  },
  reducers: {
    getCmsPageStart: (state) => ({
      ...state,
      loading: true,
      error: false
    }),
    getCmsPageSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      cmsDetails: payload,
      error: false
    }),
    getCmsPageFailure: (state) => ({
      ...state,
      loading: false,
      cmsDetails: null,
      error: true
    })
  }
})

export default reducer

export {
  getCmsPageStart,
  getCmsPageSuccess,
  getCmsPageFailure
}
